<div>
  <ng-container *ngIf="withMainHeadline" class="mx-auto pt-[22px] px-[1.25rem] h-[calc(100%-100px)]">
    <nx-pageTitle-box class="mb-3" [label]="'Developer'" [icon]="'icon-api'" [iconToolTip]="'Developer'"
    [bcRootLvlLabel]="'Einstellungen'"
    [bcRootLvlPath]="'settings'">
    </nx-pageTitle-box>
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>

  <ng-container *ngIf="!withMainHeadline">
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>
  <ng-template #table>
    <div class="body">
      <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true">
        <p-tabPanel [header]="'coreModuleModule.developerPageComponent.tabs.api' | translate ">
          <div class="mt-[1.25rem]">
            <app-api-keys/>
          </div>
        </p-tabPanel>
        <p-tabPanel [header]=" 'coreModuleModule.developerPageComponent.tabs.logs' | translate ">
          <div class="mt-[1.25rem]">
            <app-http-logs class="full"/>
          </div>
        </p-tabPanel>
        <p-tabPanel [header]=" 'coreModuleModule.developerPageComponent.tabs.webhooks' | translate ">
          <div class="mt-[1.25rem]">
            <app-subscriptions class="full"/>
          </div>
        </p-tabPanel>
        <p-tabPanel [header]=" 'coreModuleModule.developerPageComponent.tabs.events' | translate ">
          <div class="mt-[1.25rem]">
            <app-events class="full"/>
          </div>
        </p-tabPanel>
        <p-tabPanel [header]=" 'coreModuleModule.developerPageComponent.tabs.customAttributes' | translate ">
          <div class="mt-[1.25rem]">
            <app-custom-attributes class="full"/>
          </div>
        </p-tabPanel>
    </p-tabView>
    </div>
  </ng-template>
</div>
